import React, { Component } from 'react';

var config = process.env;

// Ajuste de stock: la ÚNICA forma de mover el stock a mano desde que el guardado del producto
// dejó de tocarlo (decisión del dueño, 2026-09-08). Es admin-only y el comentario es
// OBLIGATORIO — el registro es el punto de la acción, no un adorno: antes el stock se podía
// cambiar editando cualquier campo del producto y no quedaba ni quién, ni cuándo, ni por qué.
class StockAdjustModal extends Component {

    constructor(props) {
        super(props);
        this.state = this.estadoInicial();
    }

    componentDidUpdate(prevProps) {
        // Al abrirse para OTRO producto hay que limpiar: si no, el modal arranca con el número y
        // el comentario del anterior y se ajusta el producto equivocado con el motivo de otro.
        if ((this.props.show && !prevProps.show) || prevProps.product !== this.props.product) {
            this.setState(this.estadoInicial());
        }
    }

    estadoInicial = () => ({
        stock: this.props.product != null && this.props.product.stock != null
            ? String(this.props.product.stock)
            : '',
        note: '',
        busy: false,
        error: null,
    })

    stockActual = () => {
        const p = this.props.product;
        return p != null && p.stock != null ? Number(p.stock) : null;
    }

    // La diferencia se muestra ANTES de confirmar: "poner 7" no dice nada, "sacar 3" sí.
    diferencia = () => {
        const actual = this.stockActual();
        const nuevo = Number(this.state.stock);
        if (actual == null || this.state.stock === '' || Number.isNaN(nuevo)) {
            return null;
        }
        return nuevo - actual;
    }

    puedeGuardar = () => {
        const nuevo = Number(this.state.stock);
        return this.state.note.trim() !== ''
            && this.state.stock !== ''
            && Number.isInteger(nuevo)
            && nuevo >= 0
            && this.diferencia() !== 0
            && !this.state.busy;
    }

    guardar = () => {
        if (!this.puedeGuardar()) {
            return;
        }
        this.setState({ busy: true, error: null });
        const request = {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                code: this.props.product.code,
                stock: Number(this.state.stock),
                note: this.state.note.trim(),
            }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product/stock', request)
        .then((res) => res.json())
        .then((body) => {
            if (body.error > 0) {
                this.setState({ busy: false, error: body.message || 'No se pudo ajustar el stock' });
                if (body.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return;
            }
            this.setState({ busy: false });
            // El padre recarga: este modal no sabe de dónde salió la lista que lo abrió.
            if (typeof this.props.onDone === 'function') {
                this.props.onDone(body.data);
            }
        })
        .catch(() => this.setState({ busy: false, error: 'Error de red. Probá de nuevo.' }));
    }

    renderDiferencia() {
        const dif = this.diferencia();
        if (dif == null || dif === 0) {
            return <small className="text-muted">Escribí el stock que hay de verdad.</small>;
        }
        return (
            <small className={dif > 0 ? 'text-success' : 'text-danger'}>
                {dif > 0 ? `Suma ${dif}` : `Resta ${Math.abs(dif)}`} unidad(es) al stock de esta sucursal.
            </small>
        );
    }

    render() {
        if (!this.props.show || this.props.product == null) {
            return null;
        }
        const { product } = this.props;
        const { busy, error } = this.state;
        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ borderRadius: '0.75rem' }}>
                            <div className="modal-header">
                                <div>
                                    <h5 className="modal-title mb-1">Ajustar stock</h5>
                                    <small className="text-muted">{product.name || product.code}</small>
                                </div>
                                <button type="button" className="close" aria-label="Cerrar" onClick={this.props.onClose} disabled={busy}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex justify-content-between align-items-baseline"
                                     style={{ borderBottom: '0.5px solid #eee', paddingBottom: 8, marginBottom: 12 }}>
                                    <span className="text-muted">Stock actual</span>
                                    <span style={{ fontWeight: 500, fontSize: '1.2rem' }}>
                                        {this.stockActual() != null ? this.stockActual() : '—'}
                                    </span>
                                </div>

                                <label className="d-block mb-1" htmlFor="stock-adjust-value"><small>Stock nuevo</small></label>
                                <input
                                    id="stock-adjust-value"
                                    type="number"
                                    min="0"
                                    step="1"
                                    className="form-control"
                                    value={this.state.stock}
                                    onChange={(e) => this.setState({ stock: e.target.value })}
                                    disabled={busy}
                                />
                                <div className="mb-3">{this.renderDiferencia()}</div>

                                <label className="d-block mb-1" htmlFor="stock-adjust-note">
                                    <small>Motivo <strong>(obligatorio)</strong></small>
                                </label>
                                <textarea
                                    id="stock-adjust-note"
                                    className="form-control"
                                    rows="2"
                                    maxLength={500}
                                    placeholder="¿Por qué no coincide? Ej.: se rompió una caja; apareció una en el depósito…"
                                    value={this.state.note}
                                    onChange={(e) => this.setState({ note: e.target.value })}
                                    disabled={busy}
                                />
                                <small className="text-muted">
                                    Queda registrado con tu usuario y se ve en el histórico de stock del producto.
                                </small>

                                {error && <div className="alert alert-danger mt-3 mb-0 py-2">{error}</div>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-white" onClick={this.props.onClose} disabled={busy}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-accent" onClick={this.guardar} disabled={!this.puedeGuardar()}>
                                    {busy ? 'Guardando…' : 'Ajustar stock'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        );
    }
}

export default StockAdjustModal;
